export const pictureVendor = [
  'Film_Title',
  'UCCID',
  'Age of the film',
  'Film Element',
  'Film Type',
  'Film Gauge',
  'Total Reels',
  'Director',
  'Film_Year',
  'Cinematographer',
  // 'Scanned Frames',
  'Total Frames'
];
export const label = {
  Title: 'Project Title',
  Year: 'Year of Release/Production', 
  UCCID: 'Project Id/ Code',
  'Quality Monitoring Colourist Signature with Date': 'Signature with Date',
  'Grading Supervisor  Signature with Date': 'Signature with Date',
  'NFHM Colour Grading QC Supervisor Name and Signature:':
    'NFHM QC Supervisor Name and Signature',
  'Colour Grading QC Report Checking Date': 'Grading QC Checking Date',
  Film_Title: 'Project Title',
  'Film Scanning Type': 'FILM TYPE AND SCANNING TYPE',
  Film_Year: 'Year of Release/Production',
  'Film Element': 'Nature of Source',
  'Scanned Frames': 'Total Frames',
};
export const QualityMonitorColorist = [
  'Regrading Done ( Yes / No)',
  'Reason for Regrading',
  'Quality Monitoring Colourist',
  'Quality Monitoring Colourist Signature with Date',
  'No of Shots Regraded',
  'Reference video available (Yes / No)',
  'Grading Supervisor (Vendor)',
  'Grading Supervisor  Signature with Date',
];
export const summaryIndex = ['NFHM COlOUR GRADING QC Supervisor Comments:'];
export const NFHMQCSupervisorNameandSignature = [
  'NFHM Colour Grading QC Supervisor Name and Signature:',
];
export const GradingQCCheckingDate = ['Colour Grading QC Report Checking Date'];
export const ColorGradingHeaders = [
  'Check Parameters',
  'Technical Description',
  'Warning / Pass  / Fail',
  'Remarks',
];

export const colorGradingvalidation = [
  ...pictureVendor.filter((e) => e !== 'Cinematographer'),
  ...QualityMonitorColorist,
  ...summaryIndex,
  ...NFHMQCSupervisorNameandSignature,
  ...GradingQCCheckingDate,
  ...ColorGradingHeaders,
]

export const tempElementDetails =  {
  "elementId": "84b8030a-d841-4272-8f40-1cbc62048e7c",
  "elementName": "",
  "elementValue": "",
  "elementIndex": 0,
  "elementType": "TextBox",
  "templateElementId": "bd0494dd-23c2-48b4-aba1-5a4720fff88b",
  "parentId": "",
  "hasChild": false,
  "enableByDefault": true,
  "options": []
}